<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('Invoice.invoice_differenceAdjustment')"
      width="450px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form :model="adjustBalanceForm" label-width="100px" label-position="right">
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_IncludedToBusinessNoP')">
            <el-select v-model="adjustBalanceForm.jobUuid" no="1" placeholder="请选择" style="width: 210px" @change="jobNoChange">
              <el-option
                v-for="item in jobArray"
                :key="item.jobUuid"
                :label="item.jobNo"
                :value="item.jobUuid"
              />
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('Billing.billingCharge_chargeItem')">
            <cargo-advance-select
              no="2"
              :select-type="selectTypeNames.basic_data_ChargeItem"
              filterable
              :callback-params="{key:'chargeItemId'}"
              callback-method-type="value"
              :default-value="adjustBalanceForm.chargeItemId"
              tag-name="zhName"
              style="width:210px;"
              options-width="230px"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item :label="$t('Billing.billingCharge_currency')">
            <cargo-advance-select
              no="3"
              filterable
              :clearable="false"
              :select-type="selectTypeNames.basic_data_Currency"
              :default-value="adjustBalanceForm.currency"
              style="width:210px;"
              @parentCallBack="p=>currencyChange(p.value)"
            />
          </el-form-item>
          <el-form-item :label="$t('Billing.billing_exchangeRate')">
            <num-input v-model="adjustBalanceForm.exchangeRate" no="4" :min="0" :precision="8" :truncated-precision="exchangeRatePrecision" style="width:210px" :disabled="exchangeRateEnable" />
          </el-form-item>
          <el-form-item :label="$t('Billing.billingCharge_difference')">
            <el-input-number v-model="adjustBalanceForm.differenceAmount" no="5" :controls="false" :precision="2" style="width:210px" @change="differenceAmountChange" />
          </el-form-item>

          <el-form-item v-show="differenceDateVisible" :label="$t('Billing.billingCharge_financialDate')">
            <el-date-picker
              v-model="adjustBalanceForm.differenceDate"
              no="6"
              :disabled="differenceDateDisabled"
              type="date"
              value-format="yyyy-MM-dd"
              style="width:210px"
            />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button type="primary" no="7" @click="doSaveAdjustBalance">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="8" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { loadJob2Invoice, saveDifferenceAdjustment } from '@/api/clearing/invoice'
import { cacheName, cache } from '@/utils/cacheManager'
import { getLoading } from '@/utils/utilBaseElement'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'

export default {
  name: 'DifferenceAdjustmentDialog',
  components: { CargoAdvanceSelect, NumInput },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    invoice: { type: Object, required: true }, // 发票UUID
    rbgShowChargeDetail: { type: String, required: true },
    location: { type: String, required: false }
  },
  data() {
    return {
      localCurrency: 'RMB',
      selectTypeNames: TYPE_NAMES,
      adjustBalanceForm: {
        chargeItemId: 1000, // 默认费用项ID为1000(差额调整),可通过配置参数DifferenceAdjustment进行修改
        differenceAmount: 0.0, // 差额
        differenceDate: new Date(), // 差额调整日期
        jobUuid: '',
        accountId: 0,
        businessDate: '',
        invoiceUuid: '',
        invoiceVersion: 0,
        ar: false,
        branchId: this.$store.getters.currentOfficeId,
        rbgShowChargeDetail: 'merge', // 默认发票是合并明细
        currency: '', // 币种
        exchangeRate: 0.0, // 汇率
        chargeState: ChargeConstants.STATE_VERIFIED.code // 费用状态（默认为已审核状态）
      },
      jobArray: [],
      differenceDateVisible: true, // 是否显示差额调整日期
      differenceDateDisabled: false // 是否禁用差额调整日期
    }
  },
  computed: {
    innerVisible() {
      return this.visible
    },
    exchangeRateEnable() {
      return this.adjustBalanceForm.currency && this.adjustBalanceForm.currency === this.localCurrency
    },
    exchangeRatePrecision() {
      return CurrencyUtil.getCurrencyRateDigits(this.adjustBalanceForm.currency)
    }
  },
  created() {
    this.setLocalCurrency()
  },
  async beforeMount() {
    this.adjustBalanceForm.rbgShowChargeDetail = this.rbgShowChargeDetail
    const invoice = this.invoice
    if (invoice) {
      const adjustBalanceForm = this.adjustBalanceForm
      adjustBalanceForm.invoiceUuid = invoice.uuid
      adjustBalanceForm.invoiceVersion = invoice.version
      adjustBalanceForm.ar = invoice.ar
      adjustBalanceForm.currency = invoice.currency
      adjustBalanceForm.exchangeRate = invoice.rate
      await cache.load(cacheName.CONFIG)
      adjustBalanceForm.chargeItemId = Number(cache.config.get('DifferenceAdjustment'))
      this.loading = getLoading()
      await loadJob2Invoice({ keys: [invoice.uuid] }).then(res => {
        if (res.data && res.data.length > 0) {
          this.jobArray = res.data
          this.adjustBalanceForm.jobUuid = res.data[0].jobUuid
          this.adjustBalanceForm.accountId = res.data[0].accountId
          this.adjustBalanceForm.businessDate = res.data[0].businessDate
          this.jobNoChange(this.adjustBalanceForm.jobUuid)
        }
      }).finally(() => {
        this.loading.close()
      })
    }
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    // 业务编号下拉框变更事件
    jobNoChange(value) {
      for (let i = 0; i < this.jobArray.length; i++) {
        const job = this.jobArray[i]
        if (job['jobUuid'] === this.adjustBalanceForm.jobUuid) {
          this.adjustBalanceForm.accountId = job['accountId']
          this.adjustBalanceForm.businessDate = job['businessDate']
          this.differenceDateVisible = true
          this.differenceDateDisabled = false
          switch (job.jobState) {
            case SystemConstants.STATE_OPERATING.code:
            case SystemConstants.STATE_PRE_COMMIT.code:
              this.adjustBalanceForm.chargeState = ChargeConstants.STATE_UNCOMMIT.code
              this.adjustBalanceForm.differenceDate = ''
              this.differenceDateDisabled = true
              break
            case SystemConstants.STATE_COMMITED.code:
              this.adjustBalanceForm.chargeState = ChargeConstants.STATE_COMMITED.code
              this.adjustBalanceForm.differenceDate = ''
              this.differenceDateDisabled = true
              break
            case SystemConstants.STATE_VERIFIED.code:
              if (Number(cache.config.get('AutoApproveInvoiceDifferenceAdjustment')) === 0) {
                this.adjustBalanceForm.chargeState = ChargeConstants.STATE_COMMITED.code
                this.differenceDateVisible = false
                this.adjustBalanceForm.differenceDate = ''
              } else {
                this.adjustBalanceForm.chargeState = ChargeConstants.STATE_VERIFIED.code
              }
              break
            default:
              this.adjustBalanceForm.chargeState = ChargeConstants.STATE_VERIFIED.code
              break
          }
          break
        }
      }
    },
    differenceAmountChange(currentValue, oldValue) {
      if (!currentValue) {
        this.adjustBalanceForm.differenceAmount = '0'
      } else {
        this.adjustBalanceForm.differenceAmount = currentValue
        this.adjustBalanceForm.differenceAmount = RateUtil.getAmountByCurrency(this.adjustBalanceForm.differenceAmount, this.adjustBalanceForm.currency)
      }
    },
    // 保存差额调整
    doSaveAdjustBalance() {
      const adjustBalanceForm = this.adjustBalanceForm
      if (!adjustBalanceForm.chargeItemId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_MaintainChargeItem'))
        return
      }
      if (!adjustBalanceForm.jobUuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectIncludedBizNo'))
        return
      }
      const amount = adjustBalanceForm.differenceAmount
      if (!amount) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterDifferential'))
        return
      }
      if (amount > 0 && amount < 0.01) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DOPNCTBLTAC'))
        return
      }
      if (amount < 0 && amount > -0.01) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NBCTBGTC'))
        return
      }
      if (this.differenceDateVisible && !this.differenceDateDisabled && !adjustBalanceForm.differenceDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterFinancialDate'))
        return
      }
      if (!adjustBalanceForm.exchangeRate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectExchangeRate'))
        return
      }
      // 校验目前发票含有的费用币种是否有超过2个与发票币种不一致
      const currencyArray = []
      currencyArray.push(this.invoice.currency)
      for (const charge of this.invoice.chargeList) {
        if (charge.currency && currencyArray.findIndex(p => p === charge.currency) < 0) {
          currencyArray.push(this.invoice.chargeCurrency2)
        }
      }
      if (currencyArray.length > 2 && currencyArray.findIndex(p => p === this.adjustBalanceForm.currency) < 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NECDFTIC').format(2))
        return
      }
      adjustBalanceForm.location = this.location
      saveDifferenceAdjustment(adjustBalanceForm).then(res => {
        this.$emit('differenceAdjustmentCallBackEvent', res.data)
      }).finally(() => {
      })
    },
    async currencyChange(value) {
      this.adjustBalanceForm.currency = value
      if (value) {
        if (value === this.localCurrency) {
          this.adjustBalanceForm.exchangeRate = 1.0
        } else {
          if (value === this.invoice.currency) { // 若差额币种=发票币种：汇率=发票汇率（ACT_INVOICE.RATE）
            this.adjustBalanceForm.exchangeRate = this.invoice.rate
          } else if (value === this.invoice.chargeCurrency1) {
            this.adjustBalanceForm.exchangeRate = this.invoice.chargeExchangeRate1
          } else if (value === this.invoice.chargeCurrency2) {
            this.adjustBalanceForm.exchangeRate = this.invoice.chargeExchangeRate2
          } else {
            this.adjustBalanceForm.exchangeRate = await RateUtil.getForeignExchangeRateSafely(this.localCurrency, value, this.invoice.invoiceDate, this.invoice.branchId, 12, false)
          }
        }
        this.adjustBalanceForm.differenceAmount = RateUtil.getAmountByCurrency(this.adjustBalanceForm.differenceAmount, this.adjustBalanceForm.currency)
      }
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
    }
  }
}
</script>
